import { z } from 'zod';

export const FormSchema = z.object({
  ma_pttt: z.string().nonempty('Mã phương thức là bắt buộc'),
  ten_pttt: z.string().nonempty('Tên phương thức là bắt buộc'),
  ten_pttt2: z.string().optional(),
  ma_ph_thuc_hddt: z.string().nonempty('Mã phương thức HĐĐT là bắt buộc'),
  status: z.string().nonempty('Trạng thái là bắt buộc')
});
export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: FormValues = {
  ma_pttt: '',
  ten_pttt: '',
  ten_pttt2: '',
  ma_ph_thuc_hddt: '',
  status: '1'
};
